import { Page } from '@/api';

export type GdprAction = 'breach' | 'blank' | 'clearLabels';

/**
 * Filters page IDs based on their current label state to prevent unnecessary API calls
 *
 * @param pageIds - Array of page IDs to filter
 * @param pages - Array of all pages with their current label states
 * @param action - The action being performed ('breach', 'blank', 'clearLabels')
 * @returns Filtered array of page IDs that can receive the specified action
 */
export const filterPagesByAction = (pageIds: string[], pages: Page[] | null, action: GdprAction): string[] => {
  if (!pages || !pageIds.length) {
    return [];
  }

  return pageIds.filter((pageId) => {
    const page = pages.find((p) => p.id === pageId);
    if (!page) {
      return false; // Skip if page not found
    }

    switch (action) {
      case 'breach':
        // Cannot call breach on pages that already have breach label (confirmedBreach = true)
        return !page.confirmedBreach;

      case 'blank':
        // Cannot call blank on pages that already have blank label (confirmedBlank = true)
        return !page.confirmedBlank;

      case 'clearLabels':
        // Cannot call clear labels on pages with no labels
        return page.confirmedBreach || page.confirmedBlank || page.detectedBreach || page.detectedBlank;

      default:
        return false;
    }
  });
};
